var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert alert-success text-left"},[_vm._v(" "+_vm._s(_vm.$t('stornierung.kostenfrei_vorverlegen'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }